<template>
    <div class="reset-password">
        <header>
            <h1 class="headline">Set a Password</h1>
        </header>
        <v-container fluid grid-list-md class="reset-password__body">
            <form v-on:submit.prevent="submitForm" class="reset-password__form">
                <v-alert
                        class="v-alert error login__error-alert"
                        color="white--text"
                        type="error"
                        v-model="hasErrors">
                    {{ errorsSetPassword.join('') }}
                </v-alert>
                <v-container fluid grid-list-md v-if="!isPasswordReset">
                    <p>Your passwords must be at least:</p>
                    <ul>
                        <li>8 characters or more</li>
                        <li>One uppercase character</li>
                        <li>One lowercase character</li>
                        <li>One special character: <i>#?!@$%^&*-</i></li>
                    </ul>
                    <v-text-field
                            type="password"
                            label="Enter New Password"
                            placeholder=" "
                            autocomplete="new-password"
                            :error-messages="getPasswordErrorMsgs()"
                            hint=""
                            box
                            v-model="password"
                            class="mb-4">
                    </v-text-field>
                    <v-text-field
                            type="password"
                            label="Re-Enter New Password"
                            placeholder=" "
                            autocomplete="new-password"
                            :error-messages="getPasswordErrorMsgs()"
                            hint=""
                            box
                            v-model="passwordConfirm"
                            class="mb-4">
                    </v-text-field>
                    <v-btn color="#2665AE"
                           dark
                           depressed
                           type="submit"
                           class="reset-password__submit-btn"
                    >Submit
                    </v-btn>
                </v-container>
                <v-container v-if="isPasswordReset">
                    Thank you. Your password has been updated. Please
                    <a href="." @click.prevent="$router.push({ path: '/login' })">click here</a>
                    to login.
                </v-container>
            </form>
        </v-container>
    </div>
</template>

<script>
    import {sameAs, required, minLength, email} from 'vuelidate/lib/validators'
    import {mapState, mapActions, mapGetters} from 'vuex'
    import {VUE_UI_ERROR_MSGS} from '@/store/constants/ui'

    import {
        VUEX_ONBOARDING_SET_PASSWORD_REQUEST,
        VUEX_ONBOARDING_RESET_STATE
    } from '@/store/constants/onboarding'

    const errorMsgs = {
        password: 'Please enter a password',
        passwordMinReq: 'Password doesn\'t meet the minimum requirements',
        passwordSameAs: 'Passwords do not match',
        passwordMinLen: 'Passwords must be atleast 8 characters',
    };

    export default {
        name: 'reset-password',
        props: {
            userId: {
                type: String,
                default: '',
            },
            token: {
                type: String,
                default: '',
            },
        },
        data: () => ({
            showErrorMsgs: false,
            password: '',
            passwordConfirm: '',
        }),

        computed: {
            ...mapState({
                isPasswordReset: state => state.onboarding.isPasswordReset,
                errorsSetPassword: state => state.onboarding.errorsSetPassword,
            }),
            ...mapGetters({
                hasErrors: 'hasOnboardingErrorsSetPassword',
            }),
        },

        methods: {
            ...mapActions({
                setPasswordRequest: VUEX_ONBOARDING_SET_PASSWORD_REQUEST,
            }),
            getPasswordErrorMsgs: function () {
                if (this.showErrorMsgs === false)
                    return

                const password = this.$v.password

                if (password && password.required === false) {
                    return errorMsgs.password
                } else if (password.sameAs === false) {
                    return errorMsgs.passwordSameAs
                } else if (password.minReq === false) {
                    return errorMsgs.passwordMinReq
                } else if (password.minLength === false) {
                    return errorMsgs.passwordMinLen
                }
            },
            submitForm() {
                const validation = this.$v
                const formIsInvalid = validation.$invalid === true

                validation.$touch()

                if (formIsInvalid) {
                    this.showErrorMsgs = true

                    return
                }

                if (validation.$invalid === false) {
                    this.setPasswordRequest({
                        password: this.password, userId: this.userId, token: this.token
                    })
                }
            },
        },
        validations: {
            password: {
                required,
                minLength: minLength(8),
                minReq: function (value) {
                    //^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$ //includes number also
                    return /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[#?!@$%^&*-]).{8,}$/.test(value)
                },
                sameAs: sameAs('passwordConfirm')
            },
            passwordConfirm: {
                required,
            }
        },
    }
</script>